export const SERVER_URL = 'https://disaster-management-backend.herokuapp.com'